import { put, takeEvery } from 'redux-saga/effects';

import {
  ActionCreators as AttachmentsActionCreators,
  Constants as AttachmentsConstants,
} from '@savgroup-front-common/core/src/domains/attachments';

import { LOAD_FILE_INFO } from './actionTypes';

const { MYACCOUNT, CONTROL } = AttachmentsConstants.attachmentsListOrigins;

function* loadAttachments({ payload }: { payload: { fileId?: string } }) {
  const { fileId } = payload;

  if (!fileId) {
    yield put(LOAD_FILE_INFO.end());

    return;
  }

  yield put(
    AttachmentsActionCreators.loadFilesAttachmentList({
      fileId,
      type: CONTROL,
    }),
  );
  yield put(
    AttachmentsActionCreators.loadFilesAttachmentList({
      fileId,
      type: MYACCOUNT,
    }),
  );

  yield put(LOAD_FILE_INFO.end());
}

export function* fileInfoSaga() {
  yield takeEvery(LOAD_FILE_INFO.BASE as any, loadAttachments);
}
